import { useMediaQuery } from "react-responsive";
import { BREAKPOINTS } from "../constants/breakpoints";
export var useBreakpoint = function () {
    var isDesktopOrLaptop = useMediaQuery({
        minWidth: BREAKPOINTS.desktop,
    });
    var isTablet = useMediaQuery({
        minWidth: BREAKPOINTS.tablet,
        maxWidth: BREAKPOINTS.desktop - 1,
    });
    var isMobile = useMediaQuery({
        minWidth: BREAKPOINTS.mobile,
        maxWidth: BREAKPOINTS.tablet - 1,
    });
    return {
        isDesktopOrLaptop: isDesktopOrLaptop,
        isTablet: isTablet,
        isMobile: isMobile,
    };
};
